var _path, _path2, _path3, _path4, _path5;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgEnFlag = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h23.875v23.75H0V0z",
  fill: "#012169"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.798 0L11.9 8.956 20.966 0h2.91v3.068l-8.954 8.857 8.953 8.807v3.018h-2.984l-8.953-8.857-8.916 8.857H0v-2.968l8.916-8.808L0 3.167V0h2.798z",
  fill: "#FFF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.817 13.904l8.058 7.867v1.98l-10.11-9.847h2.052zm-6.864.99l.224 1.731-7.163 7.125H0l8.953-8.857zM23.875 0v.148l-9.289 9.303.075-2.177L22.01 0h1.865zM0 0l8.916 8.708H6.678L0 2.078V0z",
  fill: "#C8102E"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.99 0v23.75h5.97V0H8.99zM0 7.917v7.917h23.875V7.917H0z",
  fill: "#FFF"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 9.55v4.75h23.875V9.55H0zM10.184 0v23.75h3.582V0h-3.582z",
  fill: "#C8102E"
})));
export default SvgEnFlag;